<template>
  <div class="ma-2 ml-3 site_content">
    <comboFarm
      @fromFarm="farmInfo"
    />
    
    <div class="kepco-container" v-show="this.farmData.farm.kepco">
      <v-tabs color="#005B96" v-model="tab" class="cost-tabs">
        <v-tab v-for="(kepco, k) in cost" :key="k" class="cost-tab">
          <span class="kepco-text"> 
            <span class="info-text">한전고객번호</span><br/>
            {{ kepco.kepco_no }} </span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item   v-for="(kepco, k) in cost" :key="k">
         <div class="tab-container">
          
          <div class=" mb-flex info-container" >
            <div>
              <div class="ml-3 mb-content flex-center">
                <span class="semi-big-font">이번달 예상 청구금액</span>
                <span class="regular-font">은</span>
                <span class="big-font ml-1 mr-1">{{ addCommas(kepco.est_charge_fee) }}원</span>
                <span class="regular-font">입니다.</span>

                <span class="info-text">* 정확한 청구금액은 달라질 수 있습니다.</span>
              </div>

              <div class="ml-3 mb-content esg-content flex align-center">
                <div class="esg_line"></div>
                <span class="regular-font">🌱 이번 달 전력 사용에 따른 온실가스 배출량은</span>
                <span class="regular-font ml-1 mr-1" style="font-size:1.0rem">{{ emissions }}</span>
                <span style="font-size:0.8rem">tCO₂eq</span>
                <span class="regular-font">입니다.</span>
              </div>

            </div>
           

            <div class="flex-center mr-3 mb-center">
              <div class="kepco_info regular-font mr-2">
                <span>계약종별 | </span>
                <span>{{ kepco.contract_type }}</span>
              </div>

              <div class="kepco_info regular-font">
                <span>정기검침일 | </span>
                <span>매월 {{ kepco.sday }}일</span>
              </div>
            </div>
          </div>

          <div v-if="chartloading" class="loading-container energy-chart-layout">
            <div class="spinner"></div>
          </div>

          <div v-else class="energy-chart-layout">
            <div v-if="wattChartData[k]">
              <span class="ml-1" style=" font-size:15px; background-color:antiquewhite; padding:5px; border-radius: 10px; font-weight:600;">
                kWh
              </span>
              <Chart
                chartType="Line"
                :chartSize="chartSize" 
                :chartOptions="lineEnergyOptions"
                :chartData="wattChartData[k]" />
            </div>
          </div>
         </div>

        <div class="datepick-container">
          <datePicker
            :fr_date="fr_date" 
            :to_date="to_date" 
            @update:fr_date="updateFrDate"
            @update:to_date="updateToDate"
            @refresh="costData" 
          />
        </div>

          <div class="table_layout">
            <div v-if="tableloading" class="loading-container energy-chart-layout">
              <div class="spinner"></div>
            </div>

            <v-data-table
              v-else
              dense
              v-resize="onResize"
              :id="'time__table' + k"
              fixed-header
              :items-per-page="-1" 
              :footer-props="{ itemsPerPageOptions: [-1] }"
              :headers="headers"
              :items="kepco.data" 
              no-data-text="측정된 자료가 없습니다."
              item-key="use_edate"
              single-select
              hide-default-footer
              :sort-by="['use_edate']"
              :sort-desc="[true]"
            >
              <template v-slot:item="{ item }">
                <tr v-if="!isMobile">      
                  <td style="text-align: center;">{{ item.use_sdate }} - {{ item.use_edate }}</td>
                  <td style="text-align: center;">{{ addCommas(item.elec_pwr) }}</td>
                  <td style="text-align: center;">{{ addCommas(item.total_pwr_usage) }}</td>
                  <td style="text-align: center;">{{ addCommas(item.charge_fee) }}</td>
                </tr>

                <tr v-else class="mobile_tr">
                  <td class="mobile_td">
                    <div class="date mt-2">
                      <div> 사용기간</div>
                      <div> {{ item.use_sdate }} - {{ item.use_edate }}</div>
                    </div>

                    <div class="flex s-bt">
                        <div class="flex-title weight">요금적용전력 / 계약전력</div>

                        <div class="flex">
                          <div class="flex-content">
                            <div class="weight"></div>
                            <div>  {{ addCommas(item.elec_pwr) }} kw</div>
                          </div> 
                        </div>
                      </div>
                    <div class="line-table"></div>

                    <div class="flex s-bt">
                      <div class="flex-title weight">사용량</div>

                      <div class="flex">
                        <div class="flex-content">
                          <div class="weight"></div>
                          <div>  {{ addCommas(item.total_pwr_usage) }} kw</div>
                        </div> 
                      </div>
                    </div>

                    <div class="line-table"></div>

                    <div class="flex s-bt">
                      <div class="flex-title weight">사용량</div>

                      <div class="flex">
                        <div class="flex-content">
                          <div class="weight"></div>
                          <div>  {{ addCommas(item.charge_fee) }} 원</div>
                        </div> 
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>

          <div>
            <button class="forecast-btn" @click="elecRouter()">
              <div>⚡️</div>
              <!-- <v-icon>mdi-thunder</v-icon> -->
            </button>
          </div>
        
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_month.vue";
import Chart from "@/components/chart/Chart.vue"
import { lineEnergyOptions, dailyLineOption } from "@/components/chart/option.js";  // 옵션 불러오기


export default ({
  name:"Energy",
  components:{
    comboFarm,
    datePicker,
    Chart
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
  },
  watch: {
    chartitems: {
      handler(newValue) {
        if (Array.isArray(newValue)) {
          this.updateChartData();
        }
      },
      deep: true 
    },
  },
  data(){
    let cdate = new Date();
    let toDate = dateUtil.format(cdate, "yyyy-MM");

    let frdate = new Date(cdate.setMonth(cdate.getMonth() - 3));
    let frDate = dateUtil.format(frdate, "yyyy-MM");

    return{
      dailyLineOption:dailyLineOption,
      lineEnergyOptions:lineEnergyOptions,
      farmData: { company: {}, farm: {} },

      loading:false,
      chartloading:false,
      tableloading:false,
      isMobile: false,

      cost:[],
      tab:null,

      fr_date: frDate,
      to_date: toDate,

      items:[],
      before_acc:'',
      emissions:'',
      
      kepcoCost:[],

      esgitems:{},
      chartitems:{ },
      wattChartData:{ },
      chartSize: {
        height: '5vh',
        width: '100%',
      },

      headers: [
        { text: '사용기간', align: 'center', value: 'use_edate', filterable: true, sortable: true, groupable: false, show: true,divider: true},
        { text: '요금적용전력/계약전력', align: 'center', value: 'elec_pwr', filterable: true, sortable: true, groupable: false,divider: true, show: true },
        { text: '사용량 (kWh)', align: 'center', value: 'total_pwr_usage', filterable: false, sortable: true, groupable: false,divider: true, show: true },
        { text: '청구금액 (원)', align: 'center', value: 'charge_fee', filterable: false, sortable: true, groupable: false, divider: true, show: true },
      ],
      monthCost: {
        data: []
      }

    }
  },
  _methods: {
    farmInfo(data) {
      // console.log(data)
      this.farmData = data;
      this.refresh();
    },
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;

      else
        this.isMobile = false;
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    refresh() {
      this.wattData();
      this.EnergyPerMonth();
    },
    EnergyPerMonth() {
      this.$store.commit("resMessage", "");
      this.loading = true;

      Apis.estimateAmountForEnergyPerMonth({
        kepcoNo: this.farmData.farm.kepco,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
      }, (res) => {
        this.cost = res.data;

        this.costData();

        this.loading = false;
        this.$store.commit("resMessage", res.message);
      }).catch((err) => {
        console.log("estimateAmountForEnergyPerMonth API 호출 오류", err);
      });
    },
    wattData() {
      this.chartloading = true;

      Apis.accumulateWattPerDay({
        kepcoNo: this.farmData.farm.kepco,
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"),
      }, (res) => {
        this.items = res.data;

          // console.log(this.items)
        this.chartitems = this.items.map((item) => {
          let beforeDate = [];
          let before_acc = [];
          let currentDate = [];
          let current_acc = [];
          let day = [];


          // 당월 사용량에서 acc가 있는 제일 최신 날짜의 acc (온실가스배출량)
          const latestCurrentItem = item.current
          .filter(current => current.acc !== null && current.acc !== undefined)
          .reduce((latest, current) => {
            return new Date(current.date) > new Date(latest.date) ? current : latest;
          });

          this.emissions = (latestCurrentItem.acc*0.0004781).toFixed(2)

          // item.before.forEach((before) => {
          //   beforeDate.push(before.date);
          //   before_acc.push(before.acc !== null && before.acc !== undefined ? before.acc : null);
          //   day.push(before.day);
          // });

          item.before.forEach((before) => {
            beforeDate.push(before.date);
            before_acc.push(before.acc !== null && before.acc !== undefined ? before.acc : null);
            day.push(before.day);
            
            // before의 각 날짜에 대해 current에서 같은 날짜를 찾아서 매핑
            const matchDate = item.current.find(current => current.day === before.day);
            if (matchDate) {
              current_acc.push(matchDate.acc !== null && matchDate.acc !== undefined ? matchDate.acc : null);
            } else {
              current_acc.push(null);
            }
          });
          item.current.forEach((current) => {
            currentDate.push(current.date);
            current_acc.push(current.acc !== null && current.acc !== undefined ? current.acc : null);
          });
        

          return {
            day: day,
            beforeDate: beforeDate,
            before_acc: before_acc,
            currentDate: currentDate,
            current_acc: current_acc
          };
        });
        this.chartloading = false;
        this.updateChartData();
      
      }).catch((err) => {
        console.log("accumulateWattPerDay API 호출 오류", err);
        this.chartloading = false;
      });
    },
    updateChartData() {
      if (!Array.isArray(this.chartitems)) return;

      this.wattChartData = this.chartitems.map(item => {
        return {
          labels: item.day.map(day => `${day}일`),

          datasets: [
            {
              type: 'line',
              label: '전월사용량',
              data: item.before_acc,
              yAxisID: 'y-axis-1',
              borderColor: '#ADC0F6',
              // spanGaps: true,
              backgroundColor: "rgba(173, 192, 246, 0.4)",
            },
            {
              type: 'line',
              label: '당월사용량',
              data: item.current_acc,
              yAxisID: 'y-axis-1',
              spanGaps: true,
              pointRadius: (ctx) => {
                // 데이터가 null 값이면 동글 포인트는 안해주는걸로
                const val = ctx.raw;
                return val?.isInterpolated ? 0 : 1;
              },
              borderColor: '#80BCBD',
              backgroundColor: "rgba(128, 188, 189, 0.4)",
            }
          ],
        };
      });
    },
    costData() {
      this.tableloading = true;

      Apis.listAmountForEnergyPerMonth({
        kepcoNo: this.farmData.farm.kepco,
        from: this.fr_date,
        to: this.to_date
      }, (res) => {
        res.data.forEach((item) => {
          const KepcoNumber = this.cost.find(c => c.kepco_no === item.kepco_no);

          if (KepcoNumber) {
            KepcoNumber.data = item.data;
          } else {
            // 새로운 데이터가 있으면 추가
            this.cost.push({
              kepco_no: item.kepco_no,
              est_charge_fee: item.est_charge_fee,
              contract_type: item.contract_type,
              sday: item.sday,
              data: item.data
            });
          }
        });

        // console.log("cost", this.cost); 
        this.tableloading = false;
      }).catch((err) => {
        console.log("listAmountForEnergyPerMonth API 호출 오류", err);
        this.tableloading = false;
      });
    },
    elecRouter(){
      this.$router.push("/esg/power-forecast")
    },
    addCommas(num) {
      if (typeof num === 'number') {
        return num.toLocaleString();
      }
      return num;
    },
  },
  get methods() {
    return this._methods;
  },
  set methods(value) {
    this._methods = value;
  },
})
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.kepco-container{
  margin-top:15px;
}
.v-tabs-items{
  padding:10px !important;
  background-color: #F3F3F3 !important;
}
.cost-tabs{
  width:50%;
}
.cost-tab{
  width:100%;
  min-width:200px;
  max-width:200px;
}
.info-container{
  display:flex;
  justify-content: space-between !important;
}
.kepco-text{
  letter-spacing: -0.75px;
  font-size:1.0rem;
  font-weight:600;
}
.semi-big-font{
  font-size:18px;
  letter-spacing: -1px;
  font-weight:400;
}
.regular-font{
  font-size:15px;
}
.big-font{
  font-size:20px;
  letter-spacing: -1px;
  font-weight:600;
}
.info-text{
  font-size:0.7rem;
  color:#9c9c9c;
}
.kepco_info{
  border:1px solid #545454;
  padding:2px;
  border-radius: 5px;
}
// .cost-container{
//   margin-top:5px;
// }
.datepick-container{
  // margin-top:15px;
  height:50px;
  max-width:350px;
  margin: 0 auto;
}
.energy-chart-layout{
  margin-top:5px;
  background: #FAFBFB;
  border: 1px solid #E9E9E9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding:10px;
}
.table_layout{
  height:40vh;
}
.esg-content{
  background-color: #E8F4F8;
  color: #003D66;
}
.esg_line{
  width:3px;
  background-color: $main-color;
  height:30px;
  margin-right:5px;
}
.forecast-btn{
  position: fixed;
  bottom: 30px;
  right: 30px;

  width:50px;
  height:50px;
  background-color: $main-color;
  color:white;

  border-radius: 50%;
  
  cursor: pointer;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
}
.forecast-btn:hover{
  background-color: $menu-color; 
}     
// 모바일
@media only screen and (max-width: 768px) {
.cost-tabs{
    width:100%;
}
.cost-tab{
  min-width:120px;
  max-width:120px;
}
.mb-flex{
  flex-direction: column;
}
.mb-content{
  text-align: center;
  margin-left:0px !important;
}
.info-text{
  display:none;
}
.mb-center{
  justify-content: center;
}
.mobile_td{
  width:100vw;
}
}
</style>